import { render, staticRenderFns } from "./QueenDetail.vue?vue&type=template&id=3a6e1f42"
import script from "./QueenDetail.vue?vue&type=script&lang=js"
export * from "./QueenDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports